// extracted by mini-css-extract-plugin
export var cartContainer = "_op-4";
export var gray = "_op-1";
export var itemContainer = "_op-2";
export var itemDetails = "_op-3";
export var strong = "_op-0";